import { RpcService } from 'rpc';
export const svc = new RpcService({
    transport: 'WEBSOCKET',
    envelope: 'JSON-RPC-2.0',
    strictParameters: false,
    target: `@@discussion.rpc`,
    services: {
        get_essays: {
            parameters: [
                { name: 'begin', type: 'integer', optional: true },
                { name: 'end', type: 'integer', optional: true }
            ]
        },
        get_essay: {
            parameters: [
                { name: 'resultid', type: 'string', optional: true },
                { name: 'quizid', type: 'string', optional: true }
            ]
        },
        get_replies: {
            parameters: [
                { name: 'resultid', type: 'string', optional: true },
                { name: 'begin', type: 'integer', optional: true },
                { name: 'end', type: 'integer', optional: true }
            ]
        },
        get_reply: {
            parameters: [{ name: 'commentid', type: 'string', optional: true }]
        },
        add_reply: {
            parameters: [
                { name: 'resultid', type: 'string', optional: true },
                { name: 'reply', type: 'string', optional: true }
            ]
        }
    }
});
export default svc;
